import { TranslationKeys } from './locales';

export const ko: TranslationKeys = {
  common: {
    confirm: '확인',
    cancel: '취소',
    close: '닫기',
    save: '저장',
    delete: '삭제',
    edit: '수정',
    search: '검색',
    loading: '로딩중',
    noData: '조회된 데이터가 없습니다',
    yes: '예',
    no: '아니오',
    all: '전체',
    yearUnit: '년',
    register: '등록',
    casesUnit: '건',
  },
  
  login: {
    title: '로그인',
    id: '아이디',
    password: '비밀번호',
    loginButton: '로그인',
    findId: '아이디 찾기',
    findPassword: '비밀번호 찾기',
    idPlaceholder: '아이디를 입력해주세요.',
    passwordPlaceholder: '비밀번호를 입력해주세요.',
    keepLoggedIn: '로그인 상태 유지',
    invalidCredentials: '계정정보가 유효하지 않습니다. <br /> 아이디와 비밀번호를 확인해주세요!',
  },
  
  dashboard: {
    title: '대시보드',
    farmMachineryCount: '지도 내 농기계',
    totalMachinery: '전체',
    unit: '대',
    runningMachinery: '운행중',
    stoppedMachinery: '운행중지',
    map: '지도',
    list: '목록',
  },
  
  control: {
    title: '농기계 사고 관제',
    farmMachineryOnMap: '지도 내 농기계',
    searchPlace: '장소, 주소를 입력해주세요',
    placeAddress: '장소/주소',
    normal: '일반',
    cadastral: '지적도',
    satellite: '위성',
    eventDate: '발생일자',
    deviceName: '기기 명',
    owner: '소유자',
    status: '상태',
    running: '운행중',
    stopped: '운행중지',
    noData: '조회된 데이터가 없습니다',
    realtimeDetectionHistory: '실시간 감지내역',
    farmMachineryList: '농기계 목록',
    searchedFarmMachinery: '조회된 농기계',
    resultsPerPage: '페이지당 검색 결과 수',
    realtimeOperationStatus: '실시간 운행상황',
    danger: '위험',
    caution: '주의',
    operating: '운행 중',
    notOperating: '미운행',
    rolloverAccident: '전복사고',
    searchDeviceOwner: '기기 명, 소유자 명을 검색',
    lastOperation: '마지막 운행',
    dangerAccident: '위험(전복사고)',
    deviceList: '기기 목록',
    noDeviceFound: '조회된 기기가 없습니다',
    selectDetectionType: '감지 종류 선택',
    selectDeviceType: '기기 종류 선택',
    totalFarmMachinery: '전체 농기계',
    checkDate: '날짜를 확인해 주세요.',
    selectBothDates: '시작일과 종료일을 모두 선택해 주세요.',
    group: '그룹',
    noRecord: '주행기록없음',
    operationRecord: '운행기록',
    user: '사용자',
    unlockRolloverStatus: '차량전복 상태를 해제하시겠습니까?',
    unlockRolloverContent: '해제하시면 사고 감지 상태가 정상 처리 됩니다.\n정상 처리 이후 취소는 불가능합니다.',
    confirmUnlock: '네, 해제하겠습니다.',
    openContact: '연락처를 열람하시겠습니까?',
    protectingPrivacy: '임차인의 개인정보를 보호 중입니다.',
    openLesseeContact: '임차인의 연락처를 열람하시겠습니까?',
    openContactButton: '연락처 열람하기',
    protectDevicePrivacy: (item: string) => `기기 ${item}의 개인정보보호를 위해`,
    enterOfficerName: '열람하시는 조치자의 정확한 성명을 입력해주세요.',
    accidentDetected: (minutes: number, seconds: number) => `[ 사고 감지 후 ${minutes}분 ${seconds}초 경과 ]`,
    farmMachineryUsageReport: '농기계 사용 리포트',
    accidentDetectionRelease: '사고 감지 해제하기',
    accidentDetectionReleaseReason: '감지 해제 사유를 선택해주세요',
    accidentDetectionReleaseReasonDesc: '감지된 사고의 상황 파악을 위해, \n정확한 해제 사유를 선택해주세요.\n감지 해제 정보는 [감지 이력] 에서 확인할 수 있습니다.',
    accidentDetectionReleaseReasonDesc2: '감지된 사고의 상황 파악을 위해,',
    accidentDetectionReleaseReasonDesc3: '정확한 해제 사유를 선택해주세요.\n감지 해제 정보는 [감지 이력] 에서 확인할 수 있습니다.',
    accidentDetectionReleaseButton: '감지 해제하기',
    accidentOccurred: '발생사고',
    dangerousDriving: '위험운전',
    areaExit: '사용지역이탈',
    dangerousAreaEntry: '위험지역진입',
    batteryLow: '배터리부족',
    engineAbandonment: '시동방치',
    rolloverAccidentDetected: '현재 전복사고가 감지되었습니다.',
    checkUserSafetyImmediately: '사용자의 안전을 즉시 확인해주세요 !',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `${name}님의 농기계 사용 리포트`,
    closeReportConfirm: '리포트를 닫으시겠습니까?',
    deviceOperationStartDateMessage: '기기의 운행 시작일로 조회되었습니다.',
    currentLocationError: '현재 위치를 가져올 수 없습니다.',
    addressLookupError: '주소 조회 오류:',
    ownedDeviceList: '보유 기기 목록',
    recentOperationHistory: '최근 운행내역',
    operationEndLocation: '운행 종료 위치 :',
    noRecentOperationHistory: '최근 운행내역이 없습니다.',
    viewMap: '지도 보기',
    viewOperationHistory: '운행내역 보기',
    operationRunning: '운행중',
    operationEnd: '운행종료',
    // 소유자 정보 관련
    ownerInfo: '소유자 정보',
    ownerLabel: '소유자',
    ownerContact: '소유자 연락처',
    currentLocation: '현재 위치',
    contactViewConfirm: '연락처를 열람하시겠습니까?',
    contactViewContent: (item: string) => `기기 ${item}의 개인정보보호를 위해\n열람하시는 조치자의 정확한 성명을 입력해주세요.`,
    contactViewButton: '연락처 열람하기',
    contactViewPlaceholder: '조치자의 성명을 입력해주세요.',
    // 운행 관련
    lastOperationTime: '마지막 운행',
    noOperationRecord: '주행기록없음',
    // 차트 관련
    noDetectionInPeriod: '해당 기간 내 감지내역이 없습니다.',
    pleaseReselectDate: '날짜를 재선택해주세요.',
    // 기기 정보 모달 관련
    rentalPurpose: '임대목적',
    // 운행 기록 관련
    travelDistance: '이동거리',
    farmMachineryVoltage: '농기계 전압',
    angle: '각도',
    addressUnavailable: '주소를 확인할 수 없습니다.',
    operationLabel: '운행',
    degreeUnit: '도',
    currentStatus: '현재상태',
    dailyInspectionRequiredMachineryList: '금일 점검 요망 농기계 목록',
    // 상태 관련
    statusNormal: '정상',
    statusCaution: '주의',
    statusDanger: '위험',
    vehicleRollover: '차량전복',
    // 기기 정보 관련
    deviceType: '기기종류',
    // 감지 종류 (필터용)
    all: '전체',
    vehicleRolloverEvent: '차량전복',
    dangerousDrivingEvent: '위험운전',
    engineAbandonmentEvent: '시동방치',
    areaExitEvent: '사용지역이탈',
    batteryLowEvent: '배터리부족',
    theftDetection: '도난감지',
    dangerousAreaEntryEvent: '위험지역진입',
    // 기기 종류 (필터용)
    tractor: '트랙터',
    speedSprayer: '스피드스프레이어',
    fourWheelMotorcycle: '사륜오토바이',
    twoWheelMotorcycle: '이륜오토바이',
    oneTonTruck: '1톤 트럭',
    walkingManagement: '보행관리기',
    ridingManagement: '승용관리기',
    agriculturalHighWorkVehicle: '농업용고소작업차',
    agriculturalTransportVehicle: '농업용운반차',
    agriculturalLoader: '농업용로더',
    ridingWeedCutter: '승용예초기',
    ridingWeedRemover: '승용제초기',
    ridingTransplanter: '승용이앙기',
    fertilizerSpreader: '퇴비살포기',
    pesticideSpreader: '농약살포기',
    combine: '콤바인',
    excavator: '굴삭기',
    cultivator: '경운기',
    branchCrusher: '잔가지파쇄기',
    etc: '기타',
  },
  
  history: {
    title: '감지내역 조회',
    detectionTime: '감지일시',
    eventType: '이벤트 타입',
    deviceName: '기기 명',
    owner: '소유자',
    dateRange: '기간',
    from: '시작일',
    to: '종료일',
    searchedDetections: '조회된 감지내역',
    detectionNumber: '감지 번호',
    deviceType: '기기 종류',
    deviceName2: '기기명',
    detectionDetails: '감지 내역',
    detectedDateTime: '감지 일시',
    releasedDateTime: '해제 일시',
    releaseReason: '해제 사유',
    actionTakenBy: '조치자',
    detectionDetailView: '감지내역 상세보기',
    noDataAvailable: '조회된 데이터가 없습니다.',
    noLocationData: '해당 데이터의 위치를 알 수 없습니다.',
    downloadHistory: '감지내역 다운',
    selectDeviceType: '기기 종류 선택',
    selectDetectionType: '감지 종류 선택',
    searchDeviceOwner: '기기 명, 소유자 명을 검색',
    casesUnit: '건',
    lastOperation: '마지막운행',
    distance: '이동거리',
    machineryVoltage: '농기계 전압',
    currentStatus: '현재 상태',
    normal: '정상',
    detectionDetails2: '감지 내역',
    detectionDateTime: '감지일시',
    detectionLocation: '감지 위치',
    releaseReason2: '해제 사유',
    user2: '사용자',
    userContact: '사용자 연락처',
    guardian: '보호자',
    guardianContact: '보호자 연락처',
    guardianUserRelation: '보호자와 사용자 관계',
    operating: '운행',
    deviceTypeLabel: '기기종류',
  },
  
  manageUser: {
    title: '사용자 관리',
    userList: '사용자 목록',
    addUser: '사용자 추가',
    editUser: '사용자 수정',
    deleteUser: '사용자 삭제',
    register: '계정 등록',
    permissionManagement: '계정 권한 관리',
    cancelRegisterTitle: '사용자 등록을 취소하시겠습니까?',
    cancelRegisterContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    userName: '사용자명',
    phone: '전화번호',
    email: '이메일',
    area: '그룹',
    grade: '등급',
    status: '상태',
    searchUser: '사용자 ID, 사용자 명을 검색',
    userAccountInfo: '사용자 계정 정보',
    myAccountInfo: '나의 계정정보',
    confirmDelete: '해당 계정을 삭제하시겠습니까?',
    deleteWarning: '사용자는 해당 계정을 더이상 사용할 수 없으며,\n삭제된 계정 정보는 복구 할 수 없습니다.',
    accountName: '계정명',
    userId: 'ID',
    contact: '연락처',
    address: '주소',
    detailAddress: '상세주소',
    accountCreationDate: '계정 생성 일시',
    viewDetails: '정보 상세보기',
    viewContactRecord: '연락처 열람기록 보기',
    recordsFound: '조회된 기록',
    category: '구분',
    contactViewTime: '연락처 조회 일시',
    reader: '열람자',
    deleteAccount: '계정 삭제하기',
    resetPassword: '비밀번호 초기화하기',
    noDataFound: '조회된 데이터가 없습니다.',
    deleteMessage: '정말로 삭제하시겠습니까?',
    searchPlaceholder: '검색',
    peopleUnit: '명',
    // 추가 키들
    passwordConfirm: '비밀번호 확인',
    maxCharacters: '최대 20글자',
    passwordRequirements: '특수문자 포함 8글자 이상',
    emailExample: '예) test123@nongcall.com',
    phoneExample: '예) 010-1234-1234 / 031-123-1234',
    postcodeSearch: '우편번호 찾기',
    clear: '지우기',
    accountNamePlaceholder: '관제시스템을 사용하는 담당 기관명 입력 (최대 20글자)',
    addressPlaceholder: '관제시스템을 사용하는 담당 기관의 주소 입력',
    userImageAlt: '사용자 이미지',
    // 추가 placeholder 키들
    emailMaxCharacters: '최대 50글자',
    phoneIncludeDash: '- 포함해서 입력',
    detailAddressMaxCharacters: '최대 100글자',
    // 권한 관리 섹션
    detectionNotification: '감지상황 알림',
    functionManagement: '기능관리',
    dangerAccident: '위험(사고)',
    warningDangerousArea: '주의(위험지역 진입)',
    batteryAbnormal: '배터리 이상',
    areaExit: '사용지역 이탈',
    detectionRelease: '감지 해제 처리',
    deviceInfoModify: '기기 정보 수정',
    // 비밀번호 초기화
    resetPasswordTitle: '비밀번호를 초기화 하시겠습니까?',
    resetPasswordContent: '확인을 누르면 비밀번호가 초기화됩니다.',
    // 연락처 열람 모달
    openContact: '연락처를 열람하시겠습니까?',
    protectingPrivacy: '사용자의 개인정보보호를 위해\n열람하시는 조치자의 정확한 성명을 입력해주세요.',
    openContactButton: '연락처 열람하기',
    enterOfficerName: '조치자의 성명을 입력해주세요.',
    // 연락처 관련 표시
    noContact: '연락처 없음',
    viewContact: '연락처 열람',
    // 마이페이지 모달
    viewAccountInfo: '계정 정보를 열람하시겠습니까?',
    enterPasswordForPrivacy: '개인정보보호를 위해\n계정 비밀번호를 입력해주세요.',
    enterPasswordPlaceholder: '비밀번호를 입력해주세요.',
    confirming: '확인중..',
  },
  
  manageNok: {
    title: '추가 수신자 관리',
    nokList: '추가 수신자 목록',
    addNok: '추가 수신자 추가',
    editNok: '추가 수신자 수정',
    deleteNok: '추가 수신자 삭제',
    nokName: '이름',
    relationship: '관계',
    phone: '전화번호',
    priority: '우선순위',
    // 추가 수신자 관리 페이지
    recipientInfo: '추가 알림 수신자 정보',
    recipientContact: '추가 알림 수신자 연락처',
    ownerName: '소유자이름',
    ownerContact: '소유자연락처',
    accountCreationTime: '계정 생성 일시',
    viewDetailInfo: '정보 상세보기',
    deleteAccount: '계정 삭제하기',
    searchPlaceholder: '추가 알림 수신자 ID , 추가 알림 수신자 명을 검색',
    registerRecipient: '추가 알림 수신자 등록하기',
    sortByName: '이름 순',
    sortByContact: '추가 알림 수신자연락처 순',
    sortByOwnerName: '소유자이름 순',
    sortByOwnerContact: '소유자연락처 순',
    sortByRelationship: '관계 순',
    sortByCreationTime: '계정생성일시 순',
    defaultSort: '기본 순',
    deleteConfirmTitle: '해당 계정을 삭제하시겠습니까?',
    deleteConfirmContent: '사용자는 해당 추가 알림 수신자 정보를 더이상 사용할 수 없으며,\n삭제된 정보는 복구 할 수 없습니다.',
    noDataFound: '조회된 데이터가 없습니다.',
    // 추가 수신자 등록/수정 모달
    registerRecipientTitle: '추가 알림 수신자 등록하기',
    registerRecipientSubtitle: '소유자 선택',
    editRecipientTitle: '추가 알림 수신자 수정하기',
    editRecipientSubtitle: '소유자 선택',
    cancelRegisterTitle: '추가 알림 수신자 등록을 취소하시겠습니까?',
    cancelRegisterContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    selectOwner: '소유자 선택',
    nameLabel: '이름',
    contactLabel: '연락처',
    ownerLabel: '소유자',
    relationshipLabel: '관계',
    namePlaceholder: '추가 알림 수신자 이름',
    contactPlaceholder: '숫자만 입력 (최소 10자리)',
    relationshipPlaceholder: '관계를 입력하세요',
    contactMinLength: '연락처는 10자리 이상 입력해주세요.',
    contactOnlyNumbers: '연락처는 숫자만 입력 가능합니다.',
    registerSuccess: '추가 알림 수신자 등록 성공',
    peopleUnit: '명',
    // 보호자 상세정보/수정 모달
    detailInfoTitle: '보호자 상세정보',
    editInfoTitle: '보호자 상세정보 수정하기',
    editSuccess: '보호자 수정 성공',
    cancelEditTitle: '보호자 수정을 취소하시겠습니까?',
    cancelEditContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    editComplete: '수정완료',
    maxCharacters: '최대 20글자',
    includeDash: '"-" 포함해서 입력해 주세요.',
  },
  
  manageCustomer: {
    title: '소유자 관리',
    customerList: '소유자 목록',
    addCustomer: '소유자 추가',
    editCustomer: '소유자 수정',
    deleteCustomer: '소유자 삭제',
    customerName: '소유자명',
    phone: '연락처',
    memo: '메모',
    // 소유자 관리 페이지
    ownerInfo: '소유자 정보',
    ownerNumber: '소유자 번호',
    contact: '연락처',
    name: '이름',
    address: '주소',
    detailAddress: '상세주소',
    group: '그룹',
    viewDetailInfo: '정보 상세보기',
    deleteAccount: '계정 삭제하기',
    searchPlaceholder: '소유자 ID, 소유자 명을 검색',
    registerOwner: '소유자 등록하기',
    sortByNumber: '소유자번호 순',
    sortByContact: '아이디 순',
    sortByName: '이름 순',
    sortByAddress: '주소 순',
    sortByDetailAddress: '상세주소 순',
    sortByGroup: '그룹 순',
    defaultSort: '기본 순',
    deleteConfirmTitle: '해당 계정을 삭제하시겠습니까?',
    deleteConfirmContent: '소유자는 해당 계정을 더이상 사용할 수 없으며,\n삭제된 계정 정보는 복구 할 수 없습니다.',
    noDataFound: '조회된 데이터가 없습니다.',
    peopleUnit: '명',
    casesUnit: '건',
    noAddress: '주소 없음',
    noGroup: '그룹 없음',
    noDetailAddress: '상세 주소 없음',
    detailAddressLabel: '상세주소',
    // 소유자 상세정보 모달
    detailInfoTitle: '소유자 상세정보',
    editInfoTitle: '소유자 수정하기',
    ownerName: '소유자 명',
    ownerContact: '소유자 연락처(ID)',
    password: '비밀번호',
    joinDate: '가입날짜',
    other: '기타',
    groupLabel: '그룹',
    // 소유자 수정 모달
    modifyInfoTitle: '소유자 상세정보 수정하기',
    modifyComplete: '수정완료',
    cancelModifyTitle: '소유자 수정을 취소하시겠습니까?',
    cancelModifyContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    invalidPassword: '사용할 수 없는 비밀번호입니다.',
    passwordSpaceError: '비밀번호에 공백은 사용할 수 없습니다.',
    passwordRequirements: '영문, 숫자, 특수문자를 최소 1개씩 포함하고,\n총 8자리 이상이어야 합니다.',
    maxCharacters20: '최대 20글자',
    maxCharacters100: '최대 100글자',
    includeDash: '"-" 포함해서 입력해 주세요.',
    addressPlaceholder: '주소',
    passwordPlaceholder: '영문, 숫자, 특수문자 포함, 8자리 이상',
    groupSrLabel: '담당기관',
    // 연락처 관련
    noContact: '연락처 없음',
    viewContact: '연락처 열람',
    // 소유자 등록 모달
    registerInfoTitle: '소유자 등록하기',
    registerComplete: '등록하기',
    cancelRegisterTitle: '소유자 등록을 취소하시겠습니까?',
    cancelRegisterContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    registerSuccess: '소유자 등록 성공',
    numbersOnly: '숫자만 입력해주세요.',
    otherPlaceholder: '기타 입력',
    noDashNumbers: '- 없이 숫자만 입력',
  },
  
  manageMobility: {
    title: '농기계 관리',
    mobilityList: '농기계 목록',
    addMobility: '농기계 추가',
    mobilityName: '농기계명',
    mobilityType: '농기계 타입',
    owner: '소유자',
    status: '상태',
  },
  
  mobileList: {
    title: '농기계 관리',
    searchDeviceOwner: '기기 명, 소유자 명을 검색',
    from: '시작일',
    to: '종료일',
    selectDeviceType: '기기 종류 선택',
    selectDetectionType: '감지 종류 선택',
    group: '그룹',
    registerDevice: '기기 등록하기',
    searchedDevices: '조회된 기기',
    unit: '대',
    deviceName: '기기 명',
    deviceType: '기기 종류',
    owner: '소유자',
    operationStatus: '운행 여부',
    lastOperationDate: '최근 운행 일시',
    terminalSN: '단말기 S/N',
    machineryBattery: '농기계 Bat',
    terminalBattery: '단말기 Bat',
    testMode: '점검모드',
    deviceDetail: '기기정보 상세보기',
    viewOnMap: '지도에서 보기',
    deviceDelete: '기기 삭제하기',
    testModeActivate: '모드 상태를 변경하시겠습니까?',
    testModeDeactivate: '점검 모드를 해제하시겠습니까?',
    testModeActivateContent: '점검모드로 변경하시는 경우,\n해당 기기의 사고알림을 받을 수 없으며,\n점검모드가 해제된 이후에 다시 받을 수 있습니다.',
    testModeDeactivateContent: '점검모드를 해제하시는 경우, \n해당 기기의 사고알림이 발생할 수 있습니다.',
    deleteDevice: '해당 기기를 삭제하시겠습니까?',
    deleteDeviceContent: '기기를 삭제하실 경우, 해당 기기의 정보를 확인할 수 없으며,\n삭제된 기기의 정보는 다시 복구할 수 없습니다.',
    confirmDelete: '삭제',
    exportInstallHistory: '건 설치 이력 내보내기',
    exportCount: '건',
    noRecord: '주행기록없음',
    inspectionNeeded: '단말 점검이 필요합니다.',
    clipboardCopied: '클립보드에 복사되었습니다.',
    noDownloadAvailable: '다운로드 가능한 파일이 없습니다.',
    downloadSuccess: '파일 다운로드 성공',
  },
  
  deviceRegister: {
    title: '기기 등록하기',
    deviceName: '기기명',
    deviceNamePlaceholder: '최대 20글자',
    owner: '소유자',
    ownerPlaceholder: '소유자를 선택해주세요',
    selectOwner: '소유자',
    deviceType: '기기 종류',
    terminalSerialNumber: '단말기 시리얼 번호',
    terminalSerialPlaceholder: '기본 8자 ~ 최대 16자',
    terminalIMEI: '단말기 IMEI',
    terminalIMEIPlaceholder: '숫자 15자리',
    numbersOnly: '숫자만 입력해주세요.',
    confirmRegister: '농기기를 등록하시겠습니까?',
    confirmRegisterContent: '등록하신 내용은 추후에 수정이 가능합니다.',
    confirmRegisterButton: '등록',
    cancelRegister: '기기 등록을 취소하시겠습니까?',
    cancelRegisterContent: '확인을 누르면 입력하신 내용이 초기화됩니다.',
    checkInput: '입력을 다시 한 번 확인해주세요.',
    registerCancel: '취소',
    registerButton: '등록하기',
    registerLoading: '등록',
    noRegisterButton: '등록',
    ownerRequired: '소유자를 선택해주세요.',
    ownerError: '해당 데이터는 선택할 수 없습니다.',
    imageUploadSuccess: '사용자 이미지 등록 성공',
    imageUploadError: '이미지 등록 중 오류가 발생했습니다.',
    bulkUploadTitle: '기기 정보 엑셀 파일을 업로드해주세요.',
    bulkUploadContent: '기기 등록 정보가 작성된 엑셀 파일을 업로드해주세요.\n정확한 기기 등록을 위해 반드시 양식에 맞춰 작성된 파일만 사용해주세요.',
  },
  
  deviceDetail: {
    title: '기기정보 상세보기',
    titleEdit: '기기정보 수정하기',
    deviceName: '기기명',
    owner: '소유자',
    ownerPlaceholder: '소유자를 선택해주세요',
    ownerSelect: '소유자',
    registrationDate: '기기 등록 일시',
    deviceType: '기기 종류',
    terminalSerialNumber: '단말기 시리얼 번호',
    terminalIMEI: '단말기 IMEI',
    modifyDevice: '수정',
    modifyComplete: '완료',
    cancelModify: '기기 정보 수정을 취소하시겠습니까?',
    cancelModifyContent: '확인을 누르면 수정한 내용이 초기화됩니다.',
    ownerRequired: '소유자를 선택해주세요.',
    ownerError: '해당 데이터는 선택할 수 없습니다.',
    numbersOnly: '숫자만 입력해주세요.',
    save: '저장',
    reset: '취소',
    installPhotos: '설치 사진',
    overallView: '농기계 전체 모습',
    terminalInstallation: '단말 설치 모습',
    terminalSerialSticker: '단말 시리얼 스티커',
    powerWiringStatus: '전원 배선 상태',
    machineryTypePlate: '농기계 형식표지판',
    userPhoto: '사용자 사진',
    noImage: '이미지가 없습니다.',
  },
  
  eventTypes: {
    accident: '차량전복',
    battery: '배터리부족',
    dangerous: '위험지역진입',
    userArea: '사용지역이탈',
    emergency: '비상호출',
    keyOn: '시동방치',
  },
  
  status: {
    normal: '정상',
    warning: '경고',
    error: '오류',
    running: '운행중',
    stopped: '운행중지',
    idle: '대기중',
  },
  
  navigation: {
    home: '홈',
    accidentControl: '사고 관제',
    detectionHistory: '감지내역 조회',
    statistics: '통계',
    notice: '공지사항',
    management: '관리',
    farmMachineryManagement: '농기계 관리',
    userAccountManagement: '사용자 계정 관리',
    ownerManagement: '소유자 관리',
    additionalRecipientManagement: '추가 알림 수신자 관리',
    sitemap: '사이트맵',
    shopZone: '임대사업소 안전구역',
    shopZoneMap: '안전구역 지도',
    shopZoneAlarms: '안전구역 억제 알람',
    bigdata: '빅데이터 분석',
    logout: '로그아웃',
    honorific: '님',
  },
  
  notice: {
    title: '공지사항',
    goBack: '목록으로 돌아가기',
    confirm: '확인',
    edit: '수정',
    editContent: '내용 수정하기',
    delete: '삭제',
    deleteTitle: '공지사항을 삭제하시겠습니까?',
    deleteContent: '삭제된 공지사항은 소유자에게 표시되지 않으며,\n다시 복구할 수 없습니다.',
    register: '공지사항 등록하기',
    noNotice: '등록된 공지사항이 없습니다.',
    previousNotice: '이전 공지',
    nextNotice: '다음 공지',
    new: '신규',
    web: 'WEB',
    app: 'APP',
    write: '공지사항 작성',
    editTitle: '공지사항 수정',
    category: '공지사항 구분',
    noticeTitle: '공지 제목',
    titlePlaceholder: '제목을 입력하세요.(최대 100자)',
    cancel: '취소',
    complete: '완료',
    registerConfirm: '공지사항을 등록하시겠습니까?',
    registerContent: '공지사항의 내용을 수정하거나 삭제할 수 있으며,\n작성된 공지사항은 소유자들이 확인할 수 있습니다.',
    cancelConfirm: '목록으로 돌아가시겠습니까?',
    cancelContent: '확인 버튼을 누르시면,\n지금까지 작성된 내용은 저장되지 않습니다.',
    editBreadcrumb: '공지사항 편집',
    detailBreadcrumb: '공지 상세',
    contentPlaceholder: '본문 내용을 입력하세요 (최대 2000자)',
    imageFormatInfo: '* 첨부 가능한 이미지 파일 형식은 png, jpg, jpeg입니다.',
    imageSizeInfo: '* 이미지 파일 1개의 크기 제한은 5MB이며 최대 5개까지 첨부가 가능합니다.',
    maxLengthExceeded: '2000자를 초과하였습니다.',
    invalidFileFormat: '파일 형식을 확인해주세요.\n업로드 가능한 파일 형식은 png, jpg, jpeg입니다.',
    maxImagesExceeded: '이미지는 최대 5장까지만 첨부가 가능합니다.',
    maxSizeExceeded: '이미지는 최대 5MB까지만 첨부가 가능합니다.',
    confirmTitle: '내용을 확인해 주세요.',
  },
  
  statistics: {
    title: '감지내역 통계',
    search: '조회',
    download: '다운로드',
    invalidPeriod: '7일 이상의 기간으로\n날짜를 재선택해주세요.',
    noData: '해당 기간 내 내역이 없습니다.\n날짜를 재선택해주세요.',
    monthView: '월별로 보기',
    operatedMachinery: '운행한 농기계',
    totalMachinery: '전체 농기계',
    dailyDetections: '일별 감지내역 (건)',
    periodDetections: '기간 내 감지내역 (%)',
    hourlyDetections: '시간대별 감지내역 (건)',
    detectByType: '종류별 감지내역',
    detectList: '조회된 감지내역 리스트',
    totalDetections: '총 감지내역',
    rolloverDetections: '전복사고 감지내역',
    dangerousDrivingDetections: '위험운전 감지내역',
    outOfAreaDetections: '사용지역 이탈 감지내역',
    batteryAnomalyDetections: '배터리 이상 감지내역',
    ignitionNeglectDetections: '시동 방치 감지내역',
    cases: '건',
    units: '대',
    selectPeriod: '기간 선택',
    selectPeriodPlaceholder: '-- 기간 선택 --',
    oneMonth: '1개월',
    threeMonths: '3개월',
    sixMonths: '6개월',
    oneYear: '1년',
    timeUnit: '(단위: 시간)',
    monthlyDetections: '월별 감지내역 (건)',
    dailyView: '일별로 보기',
    detectionHistory: '감지 내역',
    dayOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
    dangerousAreaEntryDetections: '위험구역 진입 감지내역',
    user: '사용자',
    lastOperation: '마지막 운행',
    noDrivingRecord: '주행기록없음',
  },
};

